import api from "@/api";
import { formatToFileName } from "@/util.js";

const state = () => ({
  data: null,
});

const noProducts = (data) => {
  if (!data) {
    return;
  }
  return data.every(
    (department) => department.products && !department.products.length
  );
};

const actions = {
  async fetch({ commit, dispatch }, departmentId) {
    commit("UPDATE", null);
    const data = await api({
      params: { category_id: departmentId },
      url: "/123/web/products",
    });
    data.err
      ? dispatch("error/showError", data.err, { root: true })
      : noProducts(data.info.sub_categories)
      ? commit(
          "notification/SHOW",
          "Sorry products didn't load. Please refresh the page.",
          { root: true }
        )
      : commit("UPDATE", data.info);
  },
};

const getters = {
  loaded({ data }) {
    return !!data;
  },
};

const mutations = {
  UPDATE(state, department) {
    state.data = department && {
      ...department,
      src: formatToFileName(department.name),
    };
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
